import { createRoutes } from 'shared/hocs'

import { TriggersOverview } from './overview'
import { TriggerAdd } from './add'

export const Triggers = createRoutes(({ match }) => [
  {
    path: `${match.path}/add`,
    component: TriggerAdd,
  },
  {
    exact: true,
    path: match.path,
    component: TriggersOverview,
  },
])
